<template>
  <b-card no-body>
    <b-table
      :fields="fields"
      :items="dataList"
      striped
    >
      <template #cell(title)="data">
        {{ data.item.title }}
      </template>
      <template #cell(maintenance)="data">
        <div class="text-center">
          <b-form-checkbox
            :checked="Number(data.item.maintenance) === 1"
            switch
            @change="checked => setMaintenance(data.item, checked ? 1 : 0)"
          />
        </div>
      </template>
      <template #cell(control)="data">
        <div class="text-right">
          <b-button
            size="sm"
            variant="outline-primary"
            :to="$route.path + '/edit/' + data.item.id"
          >
            <FeatherIcon icon="EditIcon" />
            Güncelle
          </b-button>
        </div>
      </template>
    </b-table>
  </b-card>
</template>
<script>
import {
  BCard, BTable, BButton, BFormCheckbox,
} from 'bootstrap-vue'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

const tableName = 'components'
export default {
  name: 'Index',
  components: {
    BCard,
    BTable,
    BButton,
    BFormCheckbox,
  },
  data() {
    return {
      fields: [
        {
          key: 'title',
          label: 'BAŞLIK',
        },
        {
          key: 'maintenance',
          label: 'BAKIM MODU',
          thClass: 'text-center width-100',
          tdClass: 'text-center width-100',
        },
        {
          key: 'control',
          label: '',
          thClass: 'width-100 text-nowrap',
          tdClass: 'width-100 text-nowrap',
        },
      ],
      dataQuery: {
        select: [
          `${tableName}.id AS id`,
          `${tableName}.title AS title`,
          `${tableName}.maintenance AS maintenance`,
        ],
        where: {
          'components.seo': 1,
        },
      },
    }
  },
  computed: {
    dataList() {
      return this.$store.getters['components/dataList']
    },
    saveData() {
      return this.$store.getters['components/dataSaveStatus']
    },
  },
  watch: {
    saveData(val) {
      if (val.status === true) {
        this.showToast({
          variant: 'success', title: 'İşlem Başarılı!', icon: 'CheckIcon', text: val.message,
        })
      } else if (val.status === false) {
        this.showToast({
          variant: 'danger', title: 'İşlem Hatası!', icon: 'XIcon', text: val.message,
        })
      }
      this.getDataList()
    },
  },
  created() {
    this.getDataList()
  },
  methods: {
    setMaintenance(item, value) {
      item.maintenance = value
      this.$store.dispatch('components/saveData', {
        id: item.id,
        maintenance: value,
      })
    },
    getDataList() {
      this.$store.dispatch('components/getDataList', this.dataQuery)
    },
    showToast(params) {
      this.$toast({
        component: ToastificationContent,
        props: {
          title: params.title,
          icon: params.icon,
          text: params.text,
          variant: params.variant,
        },
      }, {
        position: 'bottom-center',
      })
    },
  },
}
</script>
